import "./Logo.css";
import logoImage from "../../../images/gotc_logo.png";
import ImageWithLoader from "../../imageWithLoader/ImageWithLoader";

function Logo() {
  return (
    <div className="logo-container">
      <ImageWithLoader src={logoImage} alt="GOTC Logo" className="logo-image" />
    </div>
  );
}

export default Logo;